import { render, staticRenderFns } from "./language-dropdown.vue?vue&type=template&id=7cd104b4&scoped=true"
import script from "./language-dropdown.vue?vue&type=script&lang=js"
export * from "./language-dropdown.vue?vue&type=script&lang=js"
import style0 from "./language-dropdown.vue?vue&type=style&index=0&id=7cd104b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd104b4",
  null
  
)

export default component.exports